import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { showAssets } from '@api/assets';

import { TAssetVisibilityDTO } from '@interfaces/assets/dto/assetsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_VISIBILITY_SHOW, ASSETS_LIST, ASSETS_LIST_SHOW_HIDE_FILTER } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutationsAssetVisibilityShow = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleShowAssets,
		isLoading: isLoadingShowAssets,
	} = useMutation<TAssetVisibilityDTO>({
		mutationKey: [ASSET_VISIBILITY_SHOW],
		mutationFn: showAssets,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetsGroupShowSuccess,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([
				ASSETS_LIST,
				ASSETS_LIST_SHOW_HIDE_FILTER,
			]);
		},
	});

	return {
		handleShowAssets,
		isLoadingShowAssets,
	};
};
